import { render } from "./SkillsManager.vue?vue&type=template&id=134767d4"
import script from "./SkillsManager.vue?vue&type=script&lang=js"
export * from "./SkillsManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__